import { instance } from "api/apiBase";
import { User } from "views/settings-users/types";

export const assigneeApi = {
  getAssignees: async (search?: string): Promise<User[]> => {
    const { data } = await instance.get<User[]>(
      `/portal/v1/boom_crm/assignees`,
      { params: search ? { search } : undefined }
    );
    return data;
  }
};
